<template>
  <div class="distributor-box">
    <!--tab栏区域-->
    <Tabs v-model="pageParams.statusTab" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in statusTabList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.statusTab === 'null'">
            <Form-item :label="$t('key1004334')" prop="ymsStatus">
              <Select v-model="pageParams.ymsStatus">
                <Option v-for="item in stockOrderStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="['null', '1', '2'].includes(pageParams.statusTab)">
            <Form-item :label="$t('key1004363')" prop="abnormalStatus">
              <Select v-model="pageParams.abnormalStatus">
                <Option v-for="item in abnormalStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="registerTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004335')" prop="stockUpCodes">
              <Input type="textarea" :placeholder="$t('key1004336')" v-model.trim="pageParams.stockUpCodes"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1006290')" prop="searchValue">
              <Input v-model.trim="pageParams.searchValue"
                :placeholder="$t('key1006289')+`${configCharacters(false)}`+'SKU、'+ `${configCharacters(false)}` +'SPU'"/>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1006170')" prop="payStatus">
              <Select v-model="pageParams.payStatus">
                <Option v-for="(item, index) in payStatusList" :value="item.value" :key="index">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box" v-if="getPermission('ymsDistributorStockUpInfo_createStockOrder')">
      <!--创建备货单-->
      <Button class="mr15" type="primary" @click="$router.push('/createBackupOrder')">{{ $t('key1001930') }}</Button>
      <!--导出订单-->
      <Dropdown transfer @on-click="changeExportBtn">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        @on-selection-change="tableChange"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--部分取消弹窗-->
    <partialCancellationModal ref="partialCancellation" @updateData="pageParamsStatus = true"></partialCancellationModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="DISTRIBUTOR"></commonLogModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1006291')"
      paramKeyColums="ymsDistributorStockUpInfoExportColumns"
      :dimensionTypeList="dimensionTypeList"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--订单提交弹窗-->
    <orderSubmissionModal ref="orderSubmission" @updateOrderData="updateOrderData"></orderSubmissionModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel, getDataSetBatchList, getDistributorWarehouseData, getEnumList, isValueEmpty, pageJump} from "@/utils/common";
import partialCancellationModal from "@/views/distributor/components/orderManage/partialCancellationModal.vue";
import commonLogModal from "@/components/common/commonLogModal.vue";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import orderSubmissionModal from "@/components/common/orderSubmissionModal.vue";


export default {
  name: 'distributorStockList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        statusTab: 'null', // 全部：null、待处理：1 、待付款：2 、备货中：3 、 收货中：31、已完结：4 、已取消：5
        ymsStatus: 'null',
        abnormalStatus: 'null', // 1.待供应商接单 2.缺货-补货中 3.缺货-已停售
        createdStartTime: null,
        createdEndTime: null,
        stockUpCodes: '',
        searchValue: '',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'left',
          fixed: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006270'),
          key: 'stockOrderInfo',
          align: 'left',
          minWidth: 280,
          render(h, params) {
            // 采购状态
            let procurementStatusTxt = '';
            let ymsStatus = params.row.ymsStatus;
            v.stockOrderStatusList.map((item) => {
              if (item.value === ymsStatus) {
                procurementStatusTxt = item.name;
              }
            });
            // 备货仓
            let stockingWarehouseName = '';
            let ymsWarehouseId = params.row.ymsWarehouseId;
            v.ymsWarehouseData.map((item) => {
              if (item.ymsWarehouseId === ymsWarehouseId) {
                stockingWarehouseName = item.name;
              }
            });
            // 订单编号
            let orderNo = [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004534')),
              h('Alink', {
                props: {
                  linkName: params.row.stockUpCode,
                  AlinkShow: true
                },
                on: {
                  AlinkBtn: () => {
                    const {href} = v.$router.resolve({
                      path: '/distributorStockListDetails',
                      query: {
                        ymsStockUpInfoId: params.row.ymsStockUpInfoId,
                        stockingWarehouseName: stockingWarehouseName
                      }
                    });
                    window.open(href, '_blank');
                  }
                }
              })
            ];
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1 flex flex-align-center'}, [orderNo]),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006271') + procurementStatusTxt),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006272') + stockingWarehouseName)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006273'),
          key: 'purchasingProductInfo',
          align: 'left',
          minWidth: 280,
          render(h, params) {
            let list = [];
            let ymsStockUpGoods = params.row.ymsStockUpGoods || [];
            if (ymsStockUpGoods.length > 0) {
              let num = ymsStockUpGoods.length - 3;
              // 备货仓
              let stockingWarehouseName = '';
              let ymsWarehouseId = params.row.ymsWarehouseId;
              v.ymsWarehouseData.map((item) => {
                if (item.ymsWarehouseId === ymsWarehouseId) {
                  stockingWarehouseName = item.name;
                }
              });
              ymsStockUpGoods.map((item, index) => {
                let skuImg = '';
                let spuImg = '';
                if (item._productInfo) {
                  skuImg = item._productInfo.primaryImage;
                  spuImg = item._productInfo._spuInfo.primaryImage;
                }
                let primaryImage = skuImg || spuImg || v.failPlaceholder;
                if (index <= 2) {
                  list.push(h('div',
                    {
                      class: 'ymsPackageGoodBox',
                      on: {
                        click() {
                          v.$router.push({
                            path: '/distributorStockListDetails',
                            query: {
                              ymsStockUpInfoId: params.row.ymsStockUpInfoId,
                              stockingWarehouseName: stockingWarehouseName
                            }
                          });
                        },
                        error($event) {
                          v.setErrorImg($event);
                        }
                      }
                    },
                    [
                      h('img', {
                        attrs: {
                          src: v.getThumbnailImage(primaryImage, '/thumb/', '70x70', true) || v.failPlaceholder,
                          onerror: v.failPlaceholder
                        },
                        class: 'ymsPackageGoodImg'
                      }),
                      h('span', {class: 'ymsPackageGoodQuantity'}, 'x' + item.quantity),
                      num > 0 && index === 2 ? h('div', {class: 'maskBox font-size-18 font-weight-bold color-white'}, '+' + num) : ''
                    ]));
                }
              });
            }
            return h('div', {class: 'flex flex-align-center'}, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          align: 'left',
          minWidth: 200,
          render(h, params) {
            let status = params.row.status;
            let ymsStatus = params.row.ymsStatus;
            let orderTotalQuantity = params.row.orderTotalQuantity; // 订单总数量
            let ymsSubPackageInfoList = params.row.ymsSubPackageInfoList || [];
            let refundAmount = params.row.refundAmount;
            let cancelledAmount = params.row.cancelledAmount;

            // 累加
            function sumProperty(arr, property) {
              return arr.reduce((total, current) => {
                let ymsSubPackageGoodsList = current.ymsSubPackageGoodsList || [];
                ymsSubPackageGoodsList.forEach(goods => {
                  total += goods[property];
                });
                return total;
              }, 0);
            }

            // 是否需要采购:0 否   1 是
            let purchaseTotal = 0;
            let notPurchasingTotal = 0;
            let purchaseList = ymsSubPackageInfoList.filter((item) => {
              return item.needPurchase === 1;
            });
            // 采购
            if (purchaseList.length > 0) {
              purchaseTotal = sumProperty(purchaseList, 'actualSortingNumber');
            }
            // 不采购
            let notPurchasingList = ymsSubPackageInfoList.filter((item) => {
              return item.needPurchase === 0;
            });
            if (notPurchasingList.length > 0) {
              notPurchasingTotal = sumProperty(notPurchasingList, 'quantity');
            }
            // 到仓数量
            let actualSortingTotal = purchaseTotal + notPurchasingTotal;
            // 上架数量
            let shelveTotal = sumProperty(ymsSubPackageInfoList, 'shelveQuantity');
            // 退款数量
            let refundTotal = sumProperty(ymsSubPackageInfoList, 'refundQuantity');
            // 取消数量
            let cancelTotal = sumProperty(ymsSubPackageInfoList, 'cancelQuantity');

            return h('div', [
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006191') + orderTotalQuantity),
              [3, 21].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004583') + actualSortingTotal) : '',
              status >= 6 && shelveTotal > 0 ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004357') + shelveTotal) : '',
              cancelTotal > 0 && cancelledAmount ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004358') + cancelTotal) : '',
              refundTotal > 0 && refundAmount ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004359') + refundTotal) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'),
          key: 'purchaseAmount',
          align: 'left',
          minWidth: 240,
          render(h, params) {
            let ymsStatus = params.row.ymsStatus; // 1.待付款、2.备货中、21.收货中 3.已完结、4.已取消
            let cancelledAmount = Number(params.row.cancelledAmount) || 0;
            let payTime = params.row.payTime;
            let status = params.row.status;
            let cancelledAmountTalg = cancelledAmount && !(!payTime && status === 8);
            let refundAmountTalg = Number(params.row.refundAmount) || 0;

            function hanleData(key, val) {
              let amount = params.row[key];
              if (!isValueEmpty(amount)) {
                let price = amountHandel(amount);
                let currency = params.row[val] || v.currencyState;
                return price + ' ' + currency;
              } else {
                return '-';
              }
            }

            let originalProductGoodsTotalPriceTxt = hanleData('originalProductGoodsTotalPrice', 'originalProductGoodsTotalPriceCurrency');
            let totalPriceText = hanleData('adjustPrice', 'distributorPaidAmountCurrency');
            /* let distributorPaidAmountTxt = hanleData('distributorPaidAmount', 'distributorPaidAmountCurrency');*/
            let refundAmountTxt = hanleData('refundAmount', 'refundAmountCurrency');
            let cancelledAmountTxt = hanleData('cancelledAmount', 'cancelledCurrency');
            return h('div', {class: 'flex flex-direction'}, [
              [1, 2, 21, 3, 4].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006274') + originalProductGoodsTotalPriceTxt) : '',
              [1, 2, 21, 3, 4].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004340') + totalPriceText) : '',
              cancelledAmountTalg ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004343') + cancelledAmountTxt) : '',
              refundAmountTalg ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004344') + refundAmountTxt) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006275'),
          key: 'timeInfo',
          align: 'left',
          minWidth: 240,
          render(h, params) {
            let ymsStatus = params.row.ymsStatus; // 1.待付款、2.备货中、3.已完结、4.已取消
            let createdTime = v.$uDate.dealTime(params.row.createdTime, 'fulltime');
            let payTime = v.$uDate.dealTime(params.row.payTime, 'fulltime');
            let shipedTime = v.$uDate.dealTime(params.row.shipedTime, 'fulltime');
            let allottedTime = v.$uDate.dealTime(params.row.allottedTime, 'fulltime');
            let cancelledTime = v.$uDate.dealTime(params.row.cancelledTime, 'fulltime');

            return h('div', {class: 'flex flex-direction'}, [
              [1, 2, 21, 3, 4].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001180') + createdTime) : '',
              [2, 21, 3, 4].includes(ymsStatus) && payTime ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004338') + payTime) : '',
              [3].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004347') + shipedTime) : '',
              [3].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004339') + allottedTime) : '',
              [4].includes(ymsStatus) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006276') + cancelledTime) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006081'),
          key: 'payStatus',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let payStatus = params.row.payStatus;
            let text = '';
            let content = params.row.returnReason;
            v.payStatusList.map((item) => {
              if (item.value === payStatus) {
                text = item.title;
              }
            });
            return h('div', {class: 'flex align-items-center'}, [
              h('p', text),
              payStatus === 3 ? h('Tooltip', {
                props: {
                  transfer: true,
                  content: content,
                  maxWidth: 300,
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  class: 'ml2 cursor',
                  props: {
                    type: 'ios-alert-outline',
                    size: 17,
                    color: '#FD5425'
                  }
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110'),
          key: 'abnormalStatus',
          align: 'left',
          minWidth: 180,
          render: (h, params) => {
            let totalOutOfStockQuantity = params.row.totalOutOfStockQuantity; // 缺货数量
            let abnormalStatus = params.row.abnormalStatus;  // 1.待供应商接单 、2.缺货-补货中 、3.缺货-已停售 、4.部分补货中 、5.部分停售
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ?
              v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            let text = abnormalStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004364') : abnormalStatus === 4 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006277') : '-';
            return h('div', [
              // 待供应商接单
              abnormalStatus === 1 ? h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006137')) : '',
              // 缺货-补货中、部分补货中
              [2, 4].includes(abnormalStatus) ? h('div', {class: 'crimsonRedColor'}, [
                h('p', text),
                estimateArrivalOfGoodsTime ? h('p', {class: 'crimsonRedColor mt4 flex flex-direction'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                  h('span', estimateArrivalOfGoodsTime)
                ]) : '',
                abnormalStatus === 4 ? h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360') + totalOutOfStockQuantity) : '',
              ]) : '',
              // 已停售
              abnormalStatus === 3 ? h('p', {class: 'crimsonRedColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084')) : '',
              // 部分停售
              abnormalStatus === 5 ? h('p', {class: 'crimsonRedColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005692')) : '',
              ![1, 2, 3, 4, 5].includes(abnormalStatus) ? h('span', '-') : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          fixed: 'right',
          width: 110,
          render(h, params) {
            let ymsStockUpInfoId = params.row.ymsStockUpInfoId;
            let ymsStatus = params.row.ymsStatus; // 1.待付款、2.备货中、3.已完结、4.已取消
            let abnormalStatus = params.row.abnormalStatus;  // 1.待供应商接单 2.缺货-补货中 3.缺货-已停售
            let status = params.row.status; // 1待调价、2待供应商接单、3待分销商付款、4待发货、5已发货、6部分到货、7已完结、8已取消
            let outOfStockQuantity = params.row.outOfStockQuantity;
            let orderTotalQuantity = params.row.orderTotalQuantity;
            let equalTalg = outOfStockQuantity === orderTotalQuantity;
            let lessThanTalg = orderTotalQuantity > outOfStockQuantity;
            let payStatus = params.row.payStatus; // 付款状态 1:待付款 2:确认中 3被退回 4已完成 5已取消
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000609'),
                    show: ymsStatus === 1 && abnormalStatus !== 1 && [1, 3].includes(payStatus)
                      && v.getPermission('ymsDistributorStockUpInfo_confirmPayment'),
                    clickFn: () => {
                      let obj = {
                        totalPrice: Number(params.row.totalPrice),
                        currency: params.row.totalPriceCurrency,
                        params: {
                          url: api.post_ymsDistributorStockUpInfo_confirmPayment,
                          query: {
                            ymsStockUpInfoId: params.row.ymsStockUpInfoId
                          }
                        }
                      }
                      v.$refs['orderSubmission'].initOrderSubmissionData(obj, true)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006278'),
                    show: (([1].includes(ymsStatus)) || ([3].includes(abnormalStatus) && equalTalg))
                      && v.getPermission('ymsDistributorStockUpInfo_confirmCancel'),
                    clickFn: () => {
                      v.cancelTransactionBtn(ymsStockUpInfoId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006141'),
                    show: (([2, 3].includes(abnormalStatus) && lessThanTalg) || (equalTalg && [2].includes(abnormalStatus)) ||
                        status !== 8 && outOfStockQuantity > 0 && outOfStockQuantity < orderTotalQuantity)
                      && v.getPermission('ymsDistributorStockUpInfo_confirmCancel'),
                    clickFn: () => {
                      v.$refs['partialCancellation'].initPartialCancellationData(ymsStockUpInfoId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsStockUpInfoId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      pendingProcessingTotal: 0,
      pendingPaymentTotal: 0,
      statusTabList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {
          value: '1',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006166')),
              h('Badge', {
                props: {
                  count: v.pendingProcessingTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {
          value: '2',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800')),
              h('Badge', {
                props: {
                  count: v.pendingPaymentTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {value: '3', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001994')},
        {value: '31', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002022')},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005933')},
        {value: '5', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')}
      ],
      registerTime: [],
      stockOrderStatusList: [
        {value: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001994')},
        {value: 21, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002022')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005933')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')}
      ],
      abnormalStatusList: [],
      abnormalStatusData: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004320')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006279')},
        {value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006280')}
      ],
      ymsWarehouseData: [],
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'essentialInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'stockUpCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001737')},
            {type: [1, 2], paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006281')},
            {type: [1, 2], paramKey: 'ymsWarehouseId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006282')},
            {type: [1], paramKey: 'skuQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004749')},
            {type: [1, 2], paramKey: 'orderTotalQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005925')},
            {type: [1, 2], paramKey: 'actualSortingQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005926')},
            {type: [1, 2], paramKey: 'shelveQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003963')},
            {type: [1, 2], paramKey: 'cancelledQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317')},
            {type: [1, 2], paramKey: 'refundQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004318')},
            {type: [1, 2], paramKey: 'originalProductGoodsTotalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005930')},
            {type: [1, 2], paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')},
            {type: [1, 2], paramKey: 'cancelledAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006283')},
            {type: [1, 2], paramKey: 'refundAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006284')},
            {type: [1, 2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {type: [1, 2], paramKey: 'payTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004475')},
            {type: [1, 2], paramKey: 'shipedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565')},
            {type: [1, 2], paramKey: 'allottedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004585')},
            {type: [1, 2], paramKey: 'abnormalStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110')},
            {type: [2], paramKey: 'ymsSku', paramValue: 'SKU'},
            {type: [2], paramKey: 'unitPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004466')},
            {type: [2], paramKey: 'paidUnitPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006285')},
            {type: [2], paramKey: 'outOfStockQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000524')},
            {type: [1, 2], paramKey: 'payStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006081')},
          ]
        }
      ],
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004476')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004477')},
      ],
      selectTableData: [],
      exportType: null,
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 付款状态
    payStatusList() {
      const ENUM_KEY = 'YmsPackageInfoOfflinePayStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = ['YmsPackageInfoOfflinePayStatusCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await this.reset();
        await this.getPendingProcessingNum();
        await getDistributorWarehouseData(this.userInfo.merchantId).then((data) => {
          this.ymsWarehouseData = data || [];
        });
        await this.search();
      })();
    },

    // 切换Tab
    changeTab(value) {
      let v = this;
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
        v.resetDate();
        v.pageParams.statusTab = value;
        v.pageParams.pageNum = 1;
        v.pageParamsStatus = true;
        v.$forceUpdate();
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let filterKeyList = ['stockUpCodes'];
      for (let key in params) {
        if (filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      let keyList = ['ymsStatus', 'statusTab', 'abnormalStatus'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      let ymsProductGoodsIdList = [];
      let ymsProductGoodsIds = [];
      v.selectTableData = [];
      v.optionBtnWidth = [];
      v.tableData = [];
      v.total = 0;
      v.getPendingProcessingNum();
      if (v.getPermission('ymsDistributorStockUpInfo_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorStockUpInfo_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.total = data.total;
              let newList = data.list || [];
              if (newList.length > 0) {
                newList.map((item) => {
                  let ymsStockUpGoods = item.ymsStockUpGoods || [];
                  let totalOutOfStockQuantity = ymsStockUpGoods.reduce((total, current) => {
                    return total + current.outOfStockQuantity;
                  }, 0);
                  item.totalOutOfStockQuantity = totalOutOfStockQuantity || 0;
                  if (ymsStockUpGoods.length > 0) {
                    ymsProductGoodsIdList.push(...ymsStockUpGoods);
                    ymsStockUpGoods.map((ele) => {
                      ymsProductGoodsIds.push(ele.ymsProductGoodsId);
                    });
                  }
                });
              } else {
                v.tableLoading = false;
              }
              if (ymsProductGoodsIds.length > 0) {
                (async () => {
                  let newData = await v.getProductInfoByIds(ymsProductGoodsIds, ymsProductGoodsIdList);
                  newList.map((item) => {
                    item.ymsStockUpGoods = newData.filter((ele) => {
                      return ele.ymsStockUpInfoId === item.ymsStockUpInfoId;
                    });
                  });
                  v.tableData = newList;
                  v.updateTableDom('selection');
                })();
              } else {
                v.tableData = newList;
                v.updateTableDom('selection');
              }
            } else {
              v.tableLoading = false;
            }
          }
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.registerTime = [];
      v.resetDate();
      v.getList();
    },
    // 重置创建时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 获取待处理的数量
    getPendingProcessingNum() {
      let v = this;
      v.axios.get(api.get_ymsDistributorStockUpInfo_queryTabTotal).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.pendingProcessingTotal = data.pendingProcessing || 0;
            v.pendingPaymentTotal = data.obligation || 0;
          } else {
            v.pendingProcessingTotal = 0;
            v.pendingPaymentTotal = 0;
          }
        }
      });
    },
    // 取消交易
    cancelTransactionBtn(ymsStockUpInfoId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006286'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006287'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004292'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          let query = {
            cancelDistributorStockUpGoodsBos: [],
            ymsStockUpInfoId: ymsStockUpInfoId
          };
          v.axios.post(api.post_ymsDistributorStockUpInfo_confirmCancel, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006288'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsStockUpInfoId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsStockUpInfoIds = v.selectTableData;
      } else {
        query.ymsStockUpInfoIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.dimensionType = obj.dimensionType;
          v.axios.post(api.post_ymsDistributorStockUpInfo_exportYmsDistributorStockUpInfoList, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 下单成功，更新操作
    updateOrderData(obj) {
      let {text} = obj;
      this.$Message.success(text);
      this.pageParamsStatus = true;
    },
  },
  watch: {
    // 监听tab栏状态
    'pageParams.statusTab': {
      handler(val) {
        this.abnormalStatusList = [];
        switch (val) {
          case 'null':
            this.abnormalStatusList = this.abnormalStatusData;
            break;
          case '1':
            this.abnormalStatusList = this.abnormalStatusData.slice(2, 4);
            break;
          case '2':
            this.abnormalStatusList = this.abnormalStatusData.slice(1, 2);
            break;
        }
      },
      immediate: true,
      deep: true
    },
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    orderSubmissionModal,
    exportFieldsModal,
    partialCancellationModal,
    commonLogModal
  }
};
</script>

<style lang="less" scoped>
.table-box /deep/ .ivu-table .ivu-table-tbody {
  .ymsPackageGoodBox {
    width: 70px;
    height: 70px;
    position: relative;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    margin: 2px 5px;
    cursor: pointer;

    .ymsPackageGoodImg {
      width: 100%;
      height: auto;
      objectFit: cover;
      verticalAlign: middle;
    }

    .ymsPackageGoodQuantity {
      padding: 2px 3px;
      border-radius: 4px;
      background-color: #fff;
      color: #000;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }

    .maskBox {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }
  }
}
</style>
